import { KanbanBoard, UnifiedKanbanCard } from "@/components/ui";

export const AccountKanban = ({ stages, filtered, onAccountClick, updateStatus, onUpdateAccount, teamMembers = [] }) => {
  const onItemMove = (account, stageKey) => {
    updateStatus(account, stageKey);
  };

  return (
    <KanbanBoard
      className="bg-slate-50/30"
      stages={stages}
      items={filtered}
      onItemMove={onItemMove}
      statusKey="paymentStatus"
      renderCard={(account) => (
        <UnifiedKanbanCard 
          item={account} 
          onClick={onAccountClick}
          onUpdate={onUpdateAccount}
          teamMembers={teamMembers}
          variant="account"
        />
      )}
    />
  );
};
